import React, { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";

interface CardNewsProps {
    foto: string;
    width: string;
    indirizzo?: string;
    settore1?: string;
    settore2?: string;
    posizioneFoto: string;
}

function CardInEvidenzaFoto({ foto, width, indirizzo, settore1, settore2, posizioneFoto }: CardNewsProps) {
    const [isHovered, setIsHovered] = useState(false);
    const navigate = useNavigate();

    const handleMouseEnter = () => setIsHovered(true);
    const handleMouseLeave = () => setIsHovered(false);

    return (
        <div
            className="card"
            style={{
                maxWidth: "23em",
                margin: "1.5em",
                border: "5px solid #032041",
                borderRadius: "15px",
                backgroundColor: isHovered ? "#447aa0" : "transparent",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                cursor: "pointer",
                overflow: "hidden"
            }}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            onClick={() => navigate(`${indirizzo}`)}
        >
            <div style={{ width: "100%" }}>
                <img
                    src={foto}
                    className="card-img-top m-auto"
                    alt="news"
                    style={{
                        width: "100%",
                        aspectRatio: "2300/1600", // Mantiene il rapporto fisso
                        objectFit: "cover",
                        objectPosition: posizioneFoto
                    }}
                />
            </div>
            <div className="card-footer"
                 style={{
                     width: "102%",
                     height: "102%",
                     backgroundColor: "#032041",
                     color: "white",
                     padding: "0.5em",
                     textAlign: "center",
                     display: "flex",
                     justifyContent: "center",
                     gap: "6px",
                 }}>
                {settore1 && <NavLink to={`/${settore1}`} style={{ color: "white" }}>{settore1}</NavLink>}
                {settore2 && <NavLink to={`/${settore2}`} style={{ color: "white" }}>{settore2}</NavLink>}
            </div>
        </div>
    );
}

export default CardInEvidenzaFoto;
